import React from 'react'

import PropTypes from "prop-types";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";



import styles from '../../assets/jss/landingPageSections/infoStyle.js'

const useStyles = makeStyles(styles);

const InfoAreaNew = (props) => {
    const classes = useStyles();
    const { title, description, iconColor, vertical, iconImg } = props;
    const iconWrapper = classNames({
      [classes.iconWrapper]: true,
      [classes[iconColor]]: true,
      [classes.iconWrapperVertical]: vertical,
    });
    const iconClasses = classNames({
      [classes.icon]: true,
      [classes.iconVertical]: vertical,
    });
  return (
    <div className={classes.infoArea}>
    <div className={iconWrapper}>
      <img
        src={iconImg}
        style={{
          background: "#fff",
          padding: "18px",
          borderRadius: "50%",
          maxWidth: "100px",
          height: "100px",
          marginBottom: "20px",
        }}
      />
      {/* <props.icon className={iconClasses} /> */}
    </div>
    <div className={classes.descriptionWrapper}>
      <h4
        className={classes.title}
        style={{
          color: "#fff",
          fontSize: "19px",
          fontWeight: "700",
          fontFamily: "Poppins",
        }}
      >
        {title}
      </h4>
      <p
        className={classes.description}
        style={{ color: "#fff", fontSize: "15px", padding: "10px" }}
      >
        {description}
      </p>
    </div>
  </div>
  )
}
InfoAreaNew.defaultProps = {
    iconColor: "gray",
  };
  
  InfoAreaNew.propTypes = {
    icon: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    iconImg: PropTypes.string.isRequired,
    vertical: PropTypes.bool,
  };
  

export default InfoAreaNew